<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
      <v-flex xs12 mb-3>
        <h1 class="max">{{ i18n('Chargebacks') }}</h1>
      </v-flex>
      <v-form @submit.prevent="applyFilters">
        <v-layout row wrap class="transactions-filter" pt-4 px-3>
          <v-flex xs8 md2 lg2 px-1>
            <v-select
              v-model="localFilters.flow"
              :items="flowOptions"
              label="Fluxo"
              item-text="text"
              item-value="value"
              box
            />
          </v-flex>

          <v-flex xs8 md2 lg2 px-1>
          <v-text-field
            v-model="localFilters.infraction_id"
            label="ID do Chargeback"
            box
          />
          </v-flex>
          
          <v-flex xs8 md2 lg2 px-1>
          <v-select
            v-model="localFilters.status"
            :items="statusOptions"
            label="Status"
            box
          />
          </v-flex>

           <v-flex xs8 md3 lg3 px-1>
            <v-text-field
              v-model="localFilters.company_wire_id"
              label="ID da Transferência"
              box
            />
          </v-flex>

          <v-flex xs8 md3 lg3 px-1>
            <v-text-field
              v-model="localFilters.bank_transaction_id"
              label="ID da Transação Bancária"
              box
            />
          </v-flex>

          <v-flex xs8 md2 lg2 px-1>
            <CompanySelect
            :model="localFilters.partnerId"
            label="Parceiro"
            @onIdSelected="this.partnerIdSelected"
            @onCompanyList="this.partnerListSelected"
            ref="filterCompanyId"
            />
          </v-flex>

          <v-flex xs8 md2 lg2 px-1>
            <CompanySelect
            :model="localFilters.subject_document_number"
            :return_document_number="true"
            :label="i18n('Nº do Doc. Cliente')"
            search_mode="document_number_prefix"
            @onDocumentNumberSelected="this.subjectDocumentNumberSelected"
            @onCompanyList="this.subjectListSelected"
            ref="filterSubjectId"
            />
          </v-flex>

          <v-flex xs8 md2 lg2 px-1>
            <DefaultFilterDate
              ref="filterStartDate"
              kind="date"
              label="Data Inicial"
              @reload="reloadStartDate"
            />
          </v-flex>

          <v-flex xs8 md2 lg2 px-1>
            <DefaultFilterDate
              ref="filterEndDate"
              kind="date"
              label="Data Final"
              @reload="reloadEndDate"
            />
          </v-flex>

          <v-flex xs6 md2 lg1 px-1>
            <v-text-field
              v-model="localFilters.per_page"
              label="Por página"
              type="number"
              box
            />
          </v-flex>

          <v-btn xs12 md3 lg2 px-1 class="filter-btn" color="#27DABC" depressed dark @click="applyFilters">
            Carregar
            <ion-icon name="funnel-outline" />
          </v-btn>
          <v-btn xs12 md3 lg2 px-1 class="reload-filter-btn" flat icon color="white" @click="resetFilters">
            <ion-icon name="reload-outline" size="large" />
          </v-btn>
        </v-layout>
      </v-form>
      <v-flex xs12>
        <AdminChargebacksList
          v-if="receivedRecords.length"
          :key="'received'"
          flow="in"
          :records="receivedRecords"
          @refresh-data="fetchchargebacks"
        />

        <AdminChargebacksList
          v-if="sentRecords.length"
          :key="'sent'"
          flow="out"
          :records="sentRecords"
          @refresh-data="fetchchargebacks"
        />
      </v-flex>
      <v-flex xs12 class="text-center" v-if="showEmptyMessage">
        <p class="body-2 grey--text">{{ i18n('Nenhum chargeback encontrado com os filtros selecionados.') }}</p>
      </v-flex>
      <v-flex xs12 class="text-center mt-4">
        <v-flex xs12 class="text-center mt-4">
          <template v-if="hasMoreItems">
            <v-btn dark color="#27DABC" @click="loadMore">
              Carregar mais
            </v-btn>
          </template>
        </v-flex>
      </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import AdminChargebacksList from '../AdminChargebacksList.vue'
import LeftBarLayout from '../layouts/LeftBarLayout.vue'
import DefaultFilterDate from '../components/filters/DefaultFilterDate.vue'
import CompanySelect from "../components/filters/CompanySelect.vue"
import utils from "../shared/Utils";

export default {
  name: 'AdminchargebacksPage',
  components: {
    layout: LeftBarLayout,
    AdminChargebacksList,
    DefaultFilterDate,
    CompanySelect
  },
  data() {
    return {
      receivedRecords: [],
      sentRecords: [],
      filterCompanySubjectList: [],
      filterCompanyPartnerList: [],
      activeFilters: {},
      localFilters: {
        flow: '',
        chargeback_id: '',
        status: 'delivered',
        partner_id: '',
        subject_document_number: '',
        company_wire_id: '',
        bank_transaction_id: '',
        from: '',
        to: '',
        per_page: 10
      },
      consolidateFilter: {
        flow: '',
        chargeback_id: '',
        status: '',
        partner_id: '',
        subject_document_number: '',
        company_wire_id: '',
        bank_transaction_id: '',
        from: '',
        to: '',
        per_page: 10
      },
      showEmptyMessage: false,
      flowOptions: [
        { text: 'Todos', value: '' },
        { text: 'Recebidas', value: 'in' },
        { text: 'Enviadas', value: 'out' }
      ],
      statusOptions: [
        'created', 'delivered', 'failed', 'closed', 'canceled', 'waiting reversal'
      ],
      filterStartDate: null,
      filterEndDate: null,
      hasMoreItems: false
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    applyFilters() {
      const dateFilters = this.buildDateFilters()
      this.consolidateFilter = {
        ...this.localFilters,
        ...dateFilters
      }
      if (!this.localFilters.partner_id && this.$refs.filterCompanyId) {
        this.$refs.filterCompanyId.selectedCompanyId = null
        this.$refs.filterCompanyId.entries = []
        this.$refs.filterCompanyId.search = null
      }

      if (!this.localFilters.subject_document_number && this.$refs.filterSubjectId) {
        this.$refs.filterSubjectId.selectedCompanyId = null
        this.$refs.filterSubjectId.entries = []
        this.$refs.filterSubjectId.search = null
      }

      this.fetchchargebacks()
    },
    partnerIdSelected(id) {
      this.localFilters.partner_id = id
    },
    partnerListSelected(companyList) {
      this.filterCompanyPartnerList = companyList
    },
    subjectDocumentNumberSelected(document_number) {
      this.localFilters.subject_document_number = document_number
    },
    subjectListSelected(companyList) {
      this.filterCompanySubjectList = companyList
    },
    async fetchchargebacks() {
      const token = this.$cookies.get('api_token')
      const makeRequest = async (flow) => {
        const params = { ...this.localFilters, ...this.buildDateFilters(), flow, status: this.localFilters.status.replace(" ", "_")}
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] == null) delete params[key]
        })
        try {
          const res = await this.$http.get(this.$root.urls.admin__list_chargebacks, {
            headers: { Authorization: `Bearer ${token}` },
            params
          })
          return res.body.data || []
        } catch (err) {
          console.error(`Erro ao buscar Chargeback (${flow}):`, err)
          return []
        }
      }
      if (!this.localFilters.flow || this.localFilters.flow === '') {
        const [received, sent] = await Promise.all([
          makeRequest('in'),
          makeRequest('out')
        ])
        this.receivedRecords = received
        this.sentRecords = sent
        this.showEmptyMessage = (this.receivedRecords.length === 0 && this.sentRecords.length === 0)
      } else if (this.localFilters.flow === 'in') {
        this.receivedRecords = await makeRequest('in')
        this.sentRecords = []
      } else if (this.localFilters.flow === 'out') {
        this.sentRecords = await makeRequest('out')
        this.receivedRecords = []
      }

      this.activeFilters = { ...this.localFilters, ...this.buildDateFilters() }
      this.hasMoreItems = (
        (!this.localFilters.flow || this.localFilters.flow === '') &&
        (this.receivedRecords.length >= this.localFilters.per_page ||
          this.sentRecords.length >= this.localFilters.per_page)
      ) || (
          this.localFilters.flow === 'in' && this.receivedRecords.length >= this.localFilters.per_page
        ) || (
          this.localFilters.flow === 'out' && this.sentRecords.length >= this.localFilters.per_page
        )
    },
    async handleFilterChange(filters) {
      const token = this.$cookies.get('api_token')
      const makeRequest = async (flow) => {
        const params = { ...filters, flow }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] == null) delete params[key]
        })

        try {
          const res = await this.$http.get(this.$root.urls.admin__list_chargebacks, {
            headers: { Authorization: `Bearer ${token}` },
            params
          })
          return res.body.data || []
        } catch (err) {
          console.error(`Erro ao buscar chargebacks (${flow}):`, err)
          return []
        }
      }

      const isLoadMore = !!filters.last_id

      let newReceived = []
      let newSent = []

      if (!filters.flow || filters.flow === '') {
        [newReceived, newSent] = await Promise.all([
          makeRequest('in'),
          makeRequest('out')
        ])
        if (isLoadMore) {
          this.receivedRecords.push(...newReceived)
          this.sentRecords.push(...newSent)
        } else {
          this.receivedRecords = newReceived
          this.sentRecords = newSent
        }
      } else if (filters.flow === 'in') {
        newReceived = await makeRequest('in')
        this.receivedRecords = isLoadMore ? [...this.receivedRecords, ...newReceived] : newReceived
        if (!isLoadMore) this.sentRecords = []
      } else if (filters.flow === 'out') {
        newSent = await makeRequest('out')
        this.sentRecords = isLoadMore ? [...this.sentRecords, ...newSent] : newSent
        if (!isLoadMore) this.receivedRecords = []
      }

      this.showEmptyMessage = (this.receivedRecords.length === 0 && this.sentRecords.length === 0)

      const loadedNewItems = (filters.flow === 'in' && newReceived.length > 0)
        || (filters.flow === 'out' && newSent.length > 0)
        || (!filters.flow && (newReceived.length > 0 || newSent.length > 0))

      this.hasMoreItems = loadedNewItems
    },
    buildDateFilters() {
      let from = ''
      let to = ''
      if (this.filterStartDate) { from = utils.filterDateFrom(this.filterStartDate, false).toISOString() }
      if (this.filterEndDate) { to = utils.filterDateTo(this.filterEndDate, false).toISOString() }
      return { from, to }
    },
    loadMore() {
      this.resetToConsolidateFilter()
      const flow = this.localFilters.flow
      const per_page = this.localFilters.per_page || 10
      const status = this.localFilters.status.replace(" ", "_")

      const baseFilters = {
        ...this.consolidateFilter
      }

      if (!flow || flow === '') {
        const lastReceived = this.receivedRecords.slice(-1)[0]
        const lastSent = this.sentRecords.slice(-1)[0]

        if (lastReceived) {
          const filtersIn = {
            ...baseFilters,
            flow: 'in',
            last_id: lastReceived.id,
            per_page,
            status: status
          }
          this.handleFilterChange(filtersIn)
        }

        if (lastSent) {
          const filtersOut = {
            ...baseFilters,
            flow: 'out',
            last_id: lastSent.id,
            per_page,
            status: status
          }
          this.handleFilterChange(filtersOut)
        }

      } else {
        const lastRecord =
          flow === 'in'
            ? this.receivedRecords.slice(-1)[0]
            : this.sentRecords.slice(-1)[0]

        if (lastRecord) {
          const filters = {
            ...baseFilters,
            flow,
            last_id: lastRecord.id,
            per_page,
            status: status
          }
          this.handleFilterChange(filters)
        }
      }
    },
    resetFilters() {
      this.localFilters = {
        flow: '',
        chargeback_id: '',
        status: '',
        partner_id: '',
        subject_document_number: '',
        company_wire_id: '',
        bank_transaction_id: '',
        from: '',
        to: '',
        per_page: 10
      }

      this.filterCompanySubjectList = []
      this.filterCompanyPartnerList = []
      if (this.$refs.filterCompanyId) {
        this.$refs.filterCompanyId.selectedCompanyId = null
        this.$refs.filterCompanyId.entries = []
        this.$refs.filterCompanyId.search = null
      }
      if (this.$refs.filterSubjectId) {
        this.$refs.filterSubjectId.selectedCompanyId = null
        this.$refs.filterSubjectId.entries = []
        this.$refs.filterSubjectId.search = null
      }
      this.filterStartDate = null
      this.$refs.filterStartDate.filterDate = null
      this.$refs.filterStartDate.$emit('reload', null)
      this.filterEndDate = null
      this.$refs.filterEndDate.filterDate = null
      this.$refs.filterEndDate.$emit('reload', null)
      this.applyFilters()

      this.hasMoreItems = false
    },
    formatDate(value) {
      if (!value) return null
      const date = new Date(value)
      return isNaN(date.getTime()) ? null : date.toISOString().slice(0, 10)
    },
    resetToConsolidateFilter() {
      this.localFilters.flow = this.consolidateFilter.flow
      this.localFilters.chargeback_id = this.consolidateFilter.chargeback_id
      this.localFilters.status = this.consolidateFilter.status
      this.localFilters.company_wire_id = this.consolidateFilter.company_wire_id
      this.localFilters.bank_transaction_id = this.consolidateFilter.bank_transaction_id
      this.localFilters.per_page = this.consolidateFilter.per_page

      const cleanFrom = this.formatDate(this.consolidateFilter.from)
      this.filterStartDate = cleanFrom
      this.$refs.filterStartDate.filterDate = cleanFrom
      this.$refs.filterStartDate.$emit('reload', cleanFrom)

      const cleanTo = this.formatDate(this.consolidateFilter.to)
      this.filterEndDate = cleanTo
      this.$refs.filterEndDate.filterDate = cleanTo
      this.$refs.filterEndDate.$emit('reload', cleanTo)

      if (this.$refs.filterCompanyId) {
        this.$refs.filterCompanyId.selectedCompanyId = this.consolidateFilter.partner_id || null
        this.$refs.filterCompanyId.search = null
      }

      if (this.$refs.filterSubjectId) {
        this.$refs.filterSubjectId.selectedCompanyId = this.consolidateFilter.subject_document_number || null
        this.$refs.filterSubjectId.search = this.consolidateFilter.subject_document_number || null
      }
    },
    reloadStartDate(date) {
      if (!date || date === '') {
        this.filterStartDate = null
      } else {
        this.filterStartDate = date
      }
    },
    reloadEndDate(date) {
      if (!date || date === '') {
        this.filterEndDate = null
      } else {
        this.filterEndDate = date
      }
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.fetchchargebacks()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ChargebackPage.vue